<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { userService } from '@/apis/user.s';
import { mapMutations } from 'vuex';
const DefaultLayout = () => import('./layouts/Default');
const AuthLayout = () => import('./layouts/Auth');

import STORAGE_NAME from '@/const/storage';

export default {
  props: ['authPage'],
  components: {
    DefaultLayout,
    AuthLayout,
  },
  data() {
    return {
      layout: 'default-layout',
    };
  },
  name: 'App',
  watch: {
    // eslint-disable-next-line prettier/prettier
    $route: function() {
      if (this.$route.query?.code) {
        this.$store.commit('setCodeRefCreateStore', this.$route.query.code);
      }
    },
  },
  methods: {
    async getLayout() {},
  },
  created() {
    if (this.$route.query?.code) {
      this.$store.commit('setCodeRefCreateStore', this.$route.query.code);
    }
  },
};
</script>
